// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"560":"pages/not-found","845":"pages/home"}[chunkId] || chunkId) + "." + {"483":"f8a7106e","560":"ea584830","845":"b7dbb09f"}[chunkId] + ".chunk.js";
};